import styles from './DashboardChart.module.css'

interface DashboardChartProps {
  title: string
  children: React.ReactNode
  className?: string
}

export function DashboardChart({ title, children, className }: DashboardChartProps) {
  return (
    <div className={`${styles.chartContainer} ${className || ''}`}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.chart}>{children}</div>
    </div>
  )
}
